import { TranslationKeys } from "locales/translationKeys"

type Result = {
    percent: TranslationKeys;
    benefit: TranslationKeys;
}

export const results: Result[] = Array(4).fill('').map((_, i) => ({
    percent: `home:real-results.results.${i}.percent` as TranslationKeys,
    benefit: `home:real-results.results.${i}.benefit` as TranslationKeys
}))